import { Injectable, Type } from '@angular/core';
import { Observable } from 'rxjs';

export interface LoginResponse {
  isAuthenticated: boolean;
  userData: unknown;
  accessToken: string;
  idToken: string;
  configId?: string;
  errorMessage?: string;
  /**
   * The `error_description` of the error callback of the identity provider, if
   * it sent one. It is set next to the `error` in `errorMessage` when a silent
   * renew came back with an OAuth error, and tells apart failures that share
   * the same `error`.
   */
  errorDescription?: string;
}

@Injectable()
export abstract class AuthorizationStrategy<Logout = unknown> {
  abstract login(returnUrl?: string | undefined): void;
  abstract logout(): Observable<Logout>;
  abstract checkAuthIncludingServer(): Observable<LoginResponse>;
  abstract isUnauthorized(modal?: Type<unknown> | null): void;
}
